import Home from 'components/home/Home.jsx'
import Footer from 'components/footer/Footer.jsx'

const App = () => (
	<div>
		<Home/>
		<Footer/>
	</div>
)

export default App
